import {
  HStack,
  Heading,
  Select,
  Stack,
  Table,
  TableCaption,
  TableContainer,
  Td,
  Text,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";

export default function Show() {
  return (
    <Stack border="1px solid #c5c5c5" borderRadius="10px" px={{base:2,md:8}} py={6} gap={1}>
      <Heading
        fontWeight={"semibold"}
        fontSize={{ base: "21px", md: "26px" }}
        pb={5}
      >
        Show
      </Heading>
      <HStack flexDir={{ base: "column", md: "row" }}>
        <Select placeholder="Everything" size="lg">
          <option>Everything</option>
        </Select>
        <HStack w="full" pt={{base:2,md:0}}>
          <Select placeholder="2022" size="lg">
            <option>2023</option>
            <option>2022</option>
            <option>2021</option>
          </Select>
          <Select placeholder="12 Months" size="lg">
            <option>12 Months</option>
            <option>6 Months</option>
            <option>3 Months</option>
          </Select>
        </HStack>
      </HStack>
      <Text
        cursor="pointer"
        fontSize={{ base: "18px", md: "21px" }}
        color="brand.400"
        fontWeight="medium"
        pt={2}
      >
        Sync to Workspace
      </Text>
      <Text
        cursor="pointer"
        fontSize={{ base: "18px", md: "21px" }}
        color="brand.400"
        fontWeight="medium"
        pb={2}
        align="end"
      >
        Export to CSV
      </Text>
      <TableContainer border="1px solid #c5c5c5" borderRadius={10}>
        <Table size={{base:"xs",sm:"md"}}>
          <TableCaption fontSize={{base:"10px",md:"16px"}}>There are no transactions to show here...</TableCaption>
          <Thead bg="#F4F4F4">
            <Tr >
              <Td textAlign={{base:"center",sm:"start"}}>Date</Td>
              <Td textAlign={{base:"center",sm:"start"}}>For</Td>
              <Td textAlign={{base:"center",sm:"start"}}>Amount</Td>
            </Tr>
          </Thead>
        </Table>
      </TableContainer>
    </Stack>
  );
}
